function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import styled from "styled-components";
import forwardRef from "../../../private/forwardRef";
import { nanoid } from "nanoid/non-secure";
var StyledSVG = styled.svg.withConfig({
  displayName: "UserFilledLg__StyledSVG",
  componentId: "sc-1num5ro-0"
})(["width:1.5rem;height:1.5rem;"]);
var UserFilledLg = forwardRef(function (props, ref) {
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(StyledSVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": props != null && props.title ? titleId : undefined
  }, props), (props == null ? void 0 : props.title) && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 3.424-1.564 6.483-4.018 8.5A10.955 10.955 0 0 1 12 23c-2.651 0-5.083-.938-6.982-2.5A10.978 10.978 0 0 1 1 12C1 5.925 5.925 1 12 1s11 4.925 11 11Zm-4.047 7.187A7.001 7.001 0 0 0 12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8 7.001 7.001 0 0 0-6.953 6.187A9.967 9.967 0 0 0 12 22a9.967 9.967 0 0 0 6.953-2.813Z",
    fill: "currentColor"
  }));
});
UserFilledLg.displayName = "UserFilledLg";
export default UserFilledLg;